import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FireHydrantAltIcon(props: IconProps) {
    return <Icon {...props} iconKey={"fire_hydrant_alt"}/>
}
